import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoUtils } from '@aodocs/shared-translation';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'aodocs-password-sign-in',
  standalone: true,
  imports: [CommonModule, TranslocoModule, MatIcon],
  providers: [
    provideTranslocoScope({
      scope: 'authentication',
      loader: TranslocoUtils.loader((lang) => import(`../../../../assets/i18n/lib/authentication/authentication-${lang}.json`)),
    }),
  ],
  templateUrl: './password-sign-in.component.html',
  styleUrls: ['./password-sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordSignInComponent {
  @Output() clickEvent = new EventEmitter<void>();
}
